import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { debugRoot, debugArea, debugGap } from '../../../../styles/debugStyles';

var countTrue = function countTrue(items) {
  return items.filter(Boolean).length;
};

var layoutStyles = {
  root: function root(_ref) {
    var props = _ref.props;
    var alignItems = props.alignItems,
        debug = props.debug,
        gap = props.gap,
        justifyItems = props.justifyItems,
        main = props.main,
        mainSize = props.mainSize,
        end = props.end,
        endSize = props.endSize,
        rootCSS = props.rootCSS,
        start = props.start,
        startSize = props.startSize,
        vertical = props.vertical;
    return Object.assign({}, debug && debugRoot(), _defineProperty({
      justifyItems: justifyItems,
      alignItems: alignItems,
      display: 'grid'
    }, vertical ? 'gridTemplateRows' : 'gridTemplateColumns', [// Heads up!
    // IE11 Doesn't support grid-gap, insert virtual columns instead
    start && startSize, gap && start && main && gap, main && mainSize, gap && (start || main) && end && gap, end && endSize].filter(Boolean).join(' ')), vertical && {
      gridAutoFlow: 'row',
      '-ms-grid-columns': '1fr'
    }, {}, rootCSS);
  },
  gap: function gap(_ref2) {
    var props = _ref2.props;
    return Object.assign({}, props.debug && debugGap({
      vertical: props.vertical
    }));
  },
  start: function start(_ref3) {
    var p = _ref3.props;
    return Object.assign({}, p.debug && debugArea(), _defineProperty({
      alignItems: 'center',
      display: 'inline-flex'
    }, p.vertical ? '-ms-grid-row' : '-ms-grid-column', '1'), p.startCSS);
  },
  main: function main(_ref4) {
    var p = _ref4.props;
    return Object.assign({}, p.debug && debugArea(), _defineProperty({
      alignItems: 'center',
      display: 'grid'
    }, p.vertical ? '-ms-grid-row' : '-ms-grid-column', countTrue([p.start, p.start && p.gap, p.main])), p.mainCSS);
  },
  end: function end(_ref5) {
    var p = _ref5.props;
    return Object.assign({}, p.debug && debugArea(), _defineProperty({
      alignItems: 'center',
      display: 'inline-flex'
    }, p.vertical ? '-ms-grid-row' : '-ms-grid-column', countTrue([p.start, p.start && p.gap, p.main, p.main && p.gap, p.end])), p.endCSS);
  }
};
export default layoutStyles;